// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1rN48","imageUploader":"EGiftCard_imageUploader__36okf"};